<div class="container">
  <div class="row justify-content-center">
    <div class="col-md-12 text-center">
      <mat-card class="col">
        <mat-card-content>
          <div class="generic-error-header">
            <ng-content></ng-content>
            <div class="title">{{ headerTitle }}</div>
          </div>
          <div class="mb-4 lead generic-error-text">{{ errorText }}</div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
